import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import { createFilter } from "redux-persist-transform-filter";
import app from "./app";
import auth from "./auth";

// you want to store only a subset of your state of appReducerFilter
const appReducerFilter = createFilter("app", ["language"]);

// you want to store only a subset of your state of authReducerFilter
const authReducerFilter = createFilter("auth", ["access_token"]);

const persistConfig = {
  key: "ipa_school_library",
  whitelist: ["app", "auth"],
  storage,
  transforms: [appReducerFilter, authReducerFilter],
  stateReconciler: autoMergeLevel2,
};

const rootReducer = combineReducers({
  app,
  auth,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
